import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { storeConfig } from "./config";

const createDocumentStore = (set, get) => ({
  listDocument: [],
  setListDocument: (docs) => set({ listDocument: docs || [] }),

  totalDocument: 0,
  setTotalDocument: (total) => set({ totalDocument: total }),

  selectedDocumentIds: [],
  setSelectedDocumentIds: (ids) => set({ selectedDocumentIds: ids || [] }),

  reset: () =>
    set({ listDocument: [], selectedDocumentIds: [], totalDocument: 0 }),
});

export const useDocumentStore = create(
  storeConfig.devtools
    ? devtools(createDocumentStore, { name: "documentStore" })
    : createDocumentStore
);
